'use strict'

import css from './loadr.styles.scss'
import template from './loadr.template.pug'

export class LoadrController {
  constructor($scope, $element) {
    'ngInject'
    Object.assign(this, { $scope, $element })
  }

  $onInit() {
    this.$scope.$on('loadr', (e, val) => {
      this.$element.toggleClass(css.visible, val)
    })
  }
}

export const umsLoadr = {
  template: template({ css }),
  controller: LoadrController,
}



// WEBPACK FOOTER //
// ./app/shared/components/loadr/loadr.component.js